// src/components/Layout.js
import React from 'react';
import {Helmet,HelmetProvider} from 'react-helmet-async';
import PropTypes from 'prop-types';
import store from 'store';
import {Header,Footer} from '../components-static/Common';
import navButtons from '../data/NavButtons';
import Popup from '../components-static/Popup';
import u from '../utilities/Utilities';
import moment from 'moment';

export default class AppLayout extends React.Component {

    state={
        isLoading:true,
        navButtons:[]
    };

    componentDidMount=(e)=>{
        //Check if tempUser is not in tempLocation, send to tempLocation
        const tempUser=store.get("tempUser");
        const tempLocation=store.get("tempLocation");
        const tempQuery = store.get("tempQuery");
        const url = this.props.url;
        if(tempUser){
            if(tempLocation.substr(0,url.length) != url){
                window.location = tempLocation + ((tempQuery) ? tempQuery : "");
                return 0;
            }
        }

        u.post({
            url:"/api/validate-token",
            data:{},
            success:(callback)=>{
                //Update cookies
                for(var key in callback){
                    store.set(key,callback[key]);
                }
                store.set("tokenTime",moment().format("YYYY-MM-DDTHH:mm:ss"));

                const hasPermission = this.checkPermission(this.props.requiredPermission,this.props.requiredField);
                if(hasPermission){
                    this.setState({isLoading:false});
                }
                else {
                    store.set("dashboard-action", "No Permission");
                    store.set("dashboard-action-label", this.props.title);
                    store.set("redirect", window.location);
                    if (typeof window != "undefined") {
                        window.location = "/dashboard";
                    }
                }
            },
            error:(error)=>{}
        });

        let nb=[];
        for(var i=0; i<navButtons.length; i++){
            if (this.checkPermission(navButtons[i].permission,navButtons[i].field)) {
                nb.push(navButtons[i]);
            }
        }
        this.setState({navButtons:nb});
    }

    checkPermission=(moduleID,combinedField)=>{
        const perms = u.getAllPermissions();

        if(typeof perms[moduleID] == "undefined"){
            return false;
        }

        if(moduleID == "combined"){
            return (parseInt(perms[moduleID][combinedField]) == 2);
        }
        else{
            return (parseInt(perms[moduleID].general) == 2)
        }
    };

    onPopup=(content)=>{
        content.cancel=this.onCancelPopup;
        this.setState({popup:content});
    }

    onCancelPopup=()=>{
        this.setState({popup:undefined});
    }

    render=()=>{
        if(this.state.isLoading){
            return (
                <div className="app-load-container"></div>
            )
        }
        return (
            <HelmetProvider>
                <div className="page-container">
                    <Helmet>
                        <title>{this.props.title}</title>
                        <meta name="viewport" content="width=device-width,initial-scale=1"/>
                        <meta name="viewport" content="height=device-height,initial-scale=1"/>
                    </Helmet>
                    <Header type="normal" hasNav={true} buttons={this.state.navButtons} current={this.props.url} pageTitle={this.props.title}/>
                    <div className="app-content">{this.props.children}</div>
                    {
                        (this.state.popup)
                            ?
                            <Popup content={this.state.popup}/>
                            :
                            ""
                    }
                    <Footer/>
                </div>
            </HelmetProvider>
        );
    }
}
AppLayout.propTypes={
    title:PropTypes.string,
    requiredPermission:PropTypes.string.isRequired,
    requiredField:PropTypes.string,
    url:PropTypes.string.isRequired,
};